module.exports = __webpack_public_path__ + "static/media/suraj.be1740f5.jpg";